var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import './ActionsCreateFunction.scss';
import { Component } from 'decorators';
import editFunctionModal from '../editFunctionModal';
import deleteFunctionModal from '../deleteFunctionModal';
import { ActionService } from '../../../../services/ActionService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { IRootScopeService, translate } from 'angular';
import { FunctionService } from '../../../../services/FunctionService';
import ActionsCreateFunctionView from './ActionsCreateFunctionView.html';
import { SidebarContentService } from 'modules/shared/SidebarContentService';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { FunctionResourceMapper } from '../../../../mappers/FunctionResourceMapper';
import { FunctionViewModel } from '../../../../models/viewModels/FunctionViewModel';
import { CodeEditorService } from '../../../../services/CodeEditor/CodeEditorService';
import { ExecuteScriptActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/ExecuteScriptActionSettings';
let ActionsCreateFunctionComponent = class ActionsCreateFunctionComponent {
    static $inject = ['ngToast', 'ModalService', 'ActionService', '$rootScope', 'FunctionService', 'BlipToastService', 'CodeEditorService', '$translate', 'BuilderSegmentService', 'SidebarContentService'];
    constructor(ngToast, ModalService, ActionService, $rootScope, FunctionService, BlipToastService, CodeEditorService, $translate, BuilderSegmentService, SidebarContentService) {
        'ngInject';
        this.ngToast = ngToast;
        this.ModalService = ModalService;
        this.ActionService = ActionService;
        this.$rootScope = $rootScope;
        this.FunctionService = FunctionService;
        this.BlipToastService = BlipToastService;
        this.CodeEditorService = CodeEditorService;
        this.$translate = $translate;
        this.BuilderSegmentService = BuilderSegmentService;
        this.SidebarContentService = SidebarContentService;
        this.buttonName = '';
        this.isEditing = false;
        this.FIND_FUNCTION_NAME_BY_FILTER_DEBOUNCE_MS = 1000;
        this.CREATE_FUNCTION_SCREEN = 'createFunction';
        this.MANAGE_FUNCTION_SCREEN = 'manageFunction';
        this.DURATION_TO_SHOW_TOAST = 5000;
        this.MAIN_SCREEN = '';
        this.onFunctionNameChange = async () => {
            this.createFunctionForm.functionName.$invalid = false;
            this.createFunctionForm.functionName.$valid = true;
            if (this.onActionChanged) {
                this.onActionChanged({ actions: this.actions });
            }
        };
        this.onDescriptionChange = () => {
            this.createFunctionForm.description.$invalid = false;
            this.createFunctionForm.description.$valid = true;
            if (this.onActionChanged) {
                this.onActionChanged({ actions: this.actions });
            }
        };
        this.onInputVariablesChange = (event) => {
            const { detail: { data }, } = event;
            this.actions.inputVariables = data;
            if (this.onActionChanged) {
                this.onActionChanged({ actions: this.actions });
            }
        };
        this.onFunctionContentChange = () => {
            this.createFunctionForm.functionContent.$invalid = false;
            this.createFunctionForm.functionContent.$valid = true;
            if (this.onActionChanged) {
                this.onActionChanged({ actions: this.actions });
            }
        };
        this.isEditorOpened = false;
        this.settings = new ExecuteScriptActionSettings();
        this.actions = new FunctionViewModel();
    }
    $onInit() {
        this.initializeSettings();
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = 'none';
        });
    }
    async initializeSettings() {
        if (!this.ActionService.getStatusNewFunction()) {
            this.actions = this.ActionService.getActions();
            this.allFunctions = this.ActionService.getAllFunctions();
            this.isEditing = this.ActionService.getIsEditing();
            return;
        }
        else {
            this.actions = new FunctionViewModel();
            this.allFunctions = await this.FunctionService.getAllFunctions();
            this.isEditing = false;
        }
    }
    $onExit() {
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = '';
        });
    }
    handleStateComponent(component) {
        if (component === this.CREATE_FUNCTION_SCREEN) {
            this.ActionService.setStatusNewFunction(true);
        }
        this.setActiveComponent({ component });
    }
    toggleCodeEditor() {
        if (this.isEditorOpened) {
            this.closeCodeEditor();
        }
        else {
            this.openCodeEditor();
            this.BuilderSegmentService.trackBlockActionLibraryExpandContent({
                Description: 'Quando o usuário clica no botão ’Expandir conteúdo’ dentro da criação/edição/visualização de uma função',
            });
        }
    }
    async openCodeEditor() {
        this.isEditorOpened = true;
        this.sidebarEditor = await this.CodeEditorService.openCodeEditor({
            code: this.actions.functionContent,
            language: 'javascript',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                this.actions.functionContent = code;
            },
            onSaveSource: () => {
                this.saveActionContent();
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on('CloseEditorIfOpenedEvent', () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise;
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    closeCodeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.sidebarEditor = undefined;
        this.isEditorOpened = false;
    }
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            editor.layout();
        }, 500);
    }
    saveActionContent() {
        this.actions.functionContent = this.actions.functionContent;
        if (this.onActionChanged) {
            this.onActionChanged({ actions: this.actions });
        }
    }
    validateOutputVariable() {
        const isValid = this.actions.settings.outputVariable &&
            !this.actions.settings.outputVariable.match(/^[a-zA-Z_$][0-9a-zA-Z_$]*$/);
        if (isValid) {
            console.error('Invalid output variable name');
        }
    }
    closeCreate() {
        if (this.onActionDeleted) {
            this.onActionDeleted({ actions: this.actions });
        }
        this.setActiveComponent({ component: '' });
    }
    async backManager() {
        if (this.isEditorOpened) {
            this.closeCodeEditor();
        }
        this.setActiveComponent({ component: this.ActionService.getState() });
    }
    async checkNameExistsWithAnotherId(functionName, functionId) {
        try {
            const foundFunction = this.allFunctions.find(func => func.functionName === functionName &&
                functionId !== func.functionId);
            if (foundFunction) {
                return true;
            }
            return false;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    async validateInputs(functionName, functionId, functionContent) {
        this.keyError = '';
        this.contentError = '';
        if (!functionName &&
            functionName.trim() === '' &&
            !functionContent &&
            functionContent.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputNotEmptyError');
            this.keyError = createError;
            const createErrorContent = await this.$translate('builder-tabs-actions.functions.createFunction.sessionFunctionContent.inputNotEmptyError');
            this.contentError = createErrorContent;
            const button = document.getElementById('expand-content');
        }
        else if (await this.checkNameExistsWithAnotherId(functionName, functionId)) {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputAlreadyExistError');
            this.keyError = createError;
            this.contentError = '';
        }
        else if (!functionName && functionName.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputNotEmptyError');
            this.keyError = createError;
            this.contentError = '';
        }
        else if (!functionContent && functionContent.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionFunctionContent.inputNotEmptyError');
            this.contentError = createError;
            this.keyError = '';
        }
        if (this.keyError !== '' || this.contentError !== '') {
            return false;
        }
        return true;
    }
    async save() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
                this.sidebarEditor = undefined;
                this.isEditorOpened = false;
            }
            const validate = await this.validateInputs(this.actions.functionName, this.actions.key, this.actions.functionContent);
            if (!validate) {
                return;
            }
            const resource = FunctionResourceMapper.mapToResource(this.actions);
            if (this.actions.key && this.actions.key.trim() !== '') {
                await this.FunctionService.updateFunction(this.actions.key, resource);
            }
            else {
                await this.FunctionService.setFunction(resource);
            }
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.message.success.created'),
                duration: this.DURATION_TO_SHOW_TOAST,
            });
            this.BuilderSegmentService.trackBlockActionLibraryFunctionCreated({
                Location: 'Library',
                Description: 'Quando o usuário clica no botão Criar função ao preencher os campos de uma nova função',
            });
            this.setActiveComponent({ component: this.MANAGE_FUNCTION_SCREEN });
        }
        catch (e) {
            console.error(e);
            const createError = await this.$translate('builder-tabs-actions.message.error.created');
            this.ngToast.danger(createError);
        }
    }
    async saveChanges() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
                this.sidebarEditor = undefined;
                this.isEditorOpened = false;
            }
            const validate = await this.validateInputs(this.actions.functionName, this.actions.key, this.actions.functionContent);
            if (!validate) {
                return;
            }
            const resource = FunctionResourceMapper.mapToResource(this.actions);
            if (this.actions.key && this.actions.key.trim() !== '') {
                await this.FunctionService.updateFunction(this.actions.key, resource);
            }
            else {
                await this.FunctionService.setFunction(resource);
            }
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.message.success.changed'),
                duration: this.DURATION_TO_SHOW_TOAST,
            });
            this.BuilderSegmentService.trackBlockActionLibraryEditFunction({
                Location: 'Library',
                Description: 'Quando o usuário clica em Salvar alterações, após fazer alguma alteração em uma função criada.',
            });
            this.setActiveComponent({ component: this.MANAGE_FUNCTION_SCREEN });
        }
        catch (e) {
            console.error(e);
            const createError = await this.$translate('builder-tabs-actions.message.error.changed');
            this.ngToast.danger(createError);
        }
    }
    async showEditFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(editFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.saveChanges();
        }
    }
    async showEditFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(editFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.saveChanges();
        }
    }
    async handleSaveChanges() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
            }
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(this.actions.key);
            this.ActionService.setActions(this.actions);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.BuilderSegmentService.trackBlockActionLibraryEditFunction({
                Location: 'Library',
                Description: 'Quando o usuário clica em Salvar alterações, após fazer alguma alteração em uma função criada.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showEditFunctionUniqueModal();
                    break;
                default:
                    await this.showEditFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteFunctionWithApplication(applicationIdentity, functionId) {
        try {
            await this.FunctionService.deleteFunctionWithApplication(applicationIdentity, functionId);
        }
        catch (e) {
            console.error(e);
            const deleteError = await this.$translate('builder-tabs-actions.message.error.deleted');
            this.ngToast.danger(deleteError);
        }
    }
    async delete() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
            }
            if (this.actions.key) {
                if (this.applications.length === 1) {
                    await this.deleteFunctionWithApplication(this.applications[0].applicationIdentity, this.applications[0].functionId);
                }
                await this.FunctionService.deleteFunction(this.actions.key);
                this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                    Location: 'Library',
                    Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
                });
                this.BlipToastService.show('success', {
                    msg: this.$translate.instant('builder-tabs-actions.message.success.deleted'),
                    duration: this.DURATION_TO_SHOW_TOAST,
                });
                this.setActiveComponent({
                    component: this.MANAGE_FUNCTION_SCREEN,
                });
            }
        }
        catch (e) {
            console.error(e);
            const deleteError = await this.$translate('builder-tabs-actions.message.error.deleted');
            this.ngToast.danger(deleteError);
        }
    }
    async showDeleteFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.delete();
        }
    }
    async showDeleteFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
    }
    async handleDelete() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
            }
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(this.actions.key);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                Location: 'Library',
                Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showDeleteFunctionUniqueModal();
                    break;
                default:
                    await this.showDeleteFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
};
ActionsCreateFunctionComponent.$inject = ['ngToast', 'ModalService', 'ActionService', '$rootScope', 'FunctionService', 'BlipToastService', 'CodeEditorService', '$translate', 'BuilderSegmentService', 'SidebarContentService'];
ActionsCreateFunctionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: ActionsCreateFunctionView,
        bindings: {
            actions: '<',
            onActionChanged: '&',
            onActionDeleted: '&',
            setActiveComponent: '&',
        },
    }),
    __metadata("design:paramtypes", [Object, Object, typeof (_a = typeof ActionService !== "undefined" && ActionService) === "function" ? _a : Object, typeof (_b = typeof IRootScopeService !== "undefined" && IRootScopeService) === "function" ? _b : Object, typeof (_c = typeof FunctionService !== "undefined" && FunctionService) === "function" ? _c : Object, typeof (_d = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _d : Object, typeof (_e = typeof CodeEditorService !== "undefined" && CodeEditorService) === "function" ? _e : Object, typeof (_f = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _f : Object, typeof (_g = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _g : Object, typeof (_h = typeof SidebarContentService !== "undefined" && SidebarContentService) === "function" ? _h : Object])
], ActionsCreateFunctionComponent);
export { ActionsCreateFunctionComponent };
